import { Pipe, PipeTransform } from '@angular/core';
import { ItemCategory } from '@planone/bau365/data-access-user';

const itemCategories = [
  {
    value: ItemCategory.all,
    label: $localize`:@@featureWatchlist-itemCategory-all:Alles`,
    resultLabels: {
      singular: $localize`:@@featureWatchlist-itemCategory-resultLabel-singular-all:Ergebnis`,
      plural: $localize`:@@featureWatchlist-itemCategory-resultLabel-plural-all:Ergebnisse`,
    },
  },
  {
    value: ItemCategory.event,
    label: $localize`:@@featureWatchlist-itemCategory-event:Events`,
    resultLabels: {
      singular: $localize`:@@featureWatchlist-itemCategory-resultLabel-singular-event:Event`,
      plural: $localize`:@@featureWatchlist-itemCategory-resultLabel-plural-event:Events`,
    },
  },
  {
    value: ItemCategory.exhibitor,
    label: $localize`:@@featureWatchlist-itemCategory-exhibitor:Aussteller`,
    resultLabels: {
      singular: $localize`:@@featureWatchlist-itemCategory-resultLabel-singular-exhibitor:Aussteller`,
      plural: $localize`:@@featureWatchlist-itemCategory-resultLabel-plural-exhibitor:Aussteller`,
    },
  },
  {
    value: ItemCategory.post,
    label: $localize`:@@featureWatchlist-itemCategory-post:Beiträge`,
    resultLabels: {
      singular: $localize`:@@featureWatchlist-itemCategory-resultLabel-singular-post:Beitrag`,
      plural: $localize`:@@featureWatchlist-itemCategory-resultLabel-plural-post:Beiträge`,
    },
  },
  {
    value: ItemCategory.product,
    label: $localize`:@@featureWatchlist-itemCategory-product:Produkte`,
    resultLabels: {
      singular: $localize`:@@featureWatchlist-itemCategory-resultLabel-singular-product:Produkt`,
      plural: $localize`:@@featureWatchlist-itemCategory-resultLabel-plural-product:Produkte`,
    },
  },
  {
    value: ItemCategory.brand,
    label: $localize`:@@featureWatchlist-itemCategory-brand:Marken`,
    resultLabels: {
      singular: $localize`:@@featureWatchlist-itemCategory-resultLabel-singular-brand:Marke`,
      plural: $localize`:@@featureWatchlist-itemCategory-resultLabel-plural-brand:Marken`,
    },
  },
];

@Pipe({ name: 'itemCategoryLabel' })
export class ItemCategoryPipe implements PipeTransform {
  transform(itemCategory: ItemCategory | undefined | null) {
    return itemCategories.find((category) => itemCategory === category.value);
  }
}
